import { Button, Heading, ModalContent, Text } from 'components';
import { FontSize, FontWeight } from 'commons';

interface Props {
  handleCloseModal: VoidFunction;
  handleConfirmLeaving: VoidFunction;
}

export function DiscountWarningModal({
  handleCloseModal,
  handleConfirmLeaving,
}: Props) {
  return (
    <ModalContent handleClose={handleCloseModal}>
      <div className="flex max-w-96 flex-col gap-6">
        <div className="flex w-full flex-col gap-4">
          <Heading as="h3" weight={FontWeight.bold} size={FontSize.font16}>
            Você tem alterações não salvas
          </Heading>

          <Text size={FontSize.font12}>
            Se você sair agora, suas alterações serão perdidas. Deseja sair sem
            salvar ou continuar editando?
          </Text>
        </div>

        <div className="flex flex-wrap-reverse gap-x-4 gap-y-2">
          <Button
            full
            className="flex-1 whitespace-nowrap"
            variant="danger"
            onClick={handleConfirmLeaving}
          >
            Sair sem salvar
          </Button>

          <Button
            full
            className="flex-1 whitespace-nowrap"
            variant="secondary"
            onClick={handleCloseModal}
          >
            Continuar editando
          </Button>
        </div>
      </div>
    </ModalContent>
  );
}
